export default __webpack_public_path__ + "static/media/profile-focus-time.e87eac2b.svg";